import { useEffect } from 'react'
import { useAppDispatch } from '@store/hooks'
import { setOnlineStatus } from '@store/slices/offlineSlice'
import { syncOfflineQueue } from '../services/syncService'
import { hydratePendingCount } from '../services/offlineWriteService'

export function useOnlineStatus(): void {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setOnlineStatus(navigator.onLine))
    if (typeof indexedDB !== 'undefined') {
      void hydratePendingCount(dispatch).catch(() => {
        // IndexedDB unavailable in test/SSR environments
      })
    }

    const handleOnline = () => {
      dispatch(setOnlineStatus(true))
      syncOfflineQueue(dispatch)
    }

    const handleOffline = () => {
      dispatch(setOnlineStatus(false))
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [dispatch])
}
